import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { organizations, singleOrganization } from '../mockData/organizations-data';

const OrganizationsApi = [
  rest.get(`${API_ROOT}organizations`, (req, res, ctx) => res(ctx.json(organizations))),
  rest.get(`${API_ROOT}organizations/8`, (req, res, ctx) => res(ctx.json(singleOrganization))),
];

export default OrganizationsApi;
